import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import { createPartnersAPI, uploadLogoPartnerAPI } from "Requests/Partners";
import { useHistory } from "react-router";
import { createToast } from "Utils/toastFunc";
import { useMutation, useQueryClient } from "react-query";
import { formatUnitsRequest } from "Utils/Units/Units";
import { useRegionsClientDomicile } from "Hooks/useRegionsClientDomicile";
import * as S from "../styles";
import { PartnerForm, PartnerFormValues } from "../components/PartnerForm";

export const CreatePartner = () => {
  const history = useHistory();
  const client = useQueryClient();

  const createPartnerMutation = useMutation({
    mutationFn: createPartnersAPI,
    onSuccess: () => client.removeQueries(["partners-list"]),
  });

  const uploadLogoPartnerMutation = useMutation({
    mutationFn: uploadLogoPartnerAPI,
  });

  const { regions } = useRegionsClientDomicile();

  const handleSubmit = async (data: PartnerFormValues) => {
    try {
      const appointments = data?.appointmentType?.map((appointment: any) => ({
        name: appointment.name,
        id: appointment.appointment
          ? Number(appointment.appointment.replace(/\D/g, ""))
          : 0,
      }));

      const hasAppointmentInfo = data?.appointmentType.some(
        (appointment) => appointment.name
      );

      const hasIntegrationCode =
        data.integration_codes.length && data.integration_codes[0].id;

      const newPartner = {
        name: data.name,
        pre_flow: data.pre_flow,
        login: data.login ? data.login : null,
        ...(hasAppointmentInfo && { appointments }),
        auth_client_id: data.auth_client_id ? data.auth_client_id : null,
        ...(data.categories.length >= 1 && {
          categories: data.categories.map((category) => category.id),
        }),
        ...(data.prod_include.length >= 1 && {
          prod_include: data.prod_include.map((product) => product.id),
        }),
        ...(data.prod_exclude.length >= 1 && {
          prod_exclude: data.prod_exclude.map((product) => product.id),
        }),
        product_needs_authorization: data.product_needs_authorization,
        free_visit: !data.free_visit,
        ...(hasIntegrationCode && {
          integration_codes: data.integration_codes,
        }),
        units: {
          ...formatUnitsRequest(data.units, regions),
        },
      };

      const response = await createPartnerMutation.mutateAsync(newPartner);
      const formData = new FormData();
      formData.append("file", data.attach as File);
      await uploadLogoPartnerMutation.mutateAsync({
        partnerId: response.id,
        file: formData,
      });
      createToast("success", "Parceiro criado com sucesso");
      history.push("/parceiros");
    } catch (error: any) {
      const hasError = error?.response?.data?.errors;

      if (hasError) {
        const errorMessage = error?.response?.data?.errors[0]?.message;

        return createToast("error", errorMessage);
      }

      createToast("error", "Não foi possível criar este parceiro");
    }
  };

  return (
    <S.Container className="entry-app-content">
      <div className="content-holder">
        <div>
          <div className="wrapper-header-content">
            <PageHeader title="Criar parceiro">
              <Breadcrumb
                list={[
                  {
                    path: "/parceiros",
                    label: "Parceiros",
                    current: false,
                  },
                  {
                    path: "/criar-parceiro",
                    label: "Criar novo parceiro",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
            <div className="buttons-container">
              <>
                <Button
                  outlined
                  borderRadius="111"
                  onClick={() => history.push("/parceiros")}
                  disabled={createPartnerMutation.isLoading}
                >
                  Cancelar
                </Button>
                <Button
                  form="partner-form"
                  type="submit"
                  borderRadius="111"
                  disabled={createPartnerMutation.isLoading}
                  loading={createPartnerMutation.isLoading}
                >
                  Criar
                </Button>
              </>
            </div>
          </div>
        </div>

        <main>
          <div className="form">
            <PartnerForm onSubmit={handleSubmit} />
          </div>
        </main>
      </div>
    </S.Container>
  );
};
